import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
};

/** One small tab of the transcript box in the call popup. */
const PanelTab = ({ active, onClick, children }: Props) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={active}
    className={cn(
      "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] transition",
      active ? "bg-white/[0.07] text-white" : "text-slate-500 hover:text-slate-300"
    )}
  >
    {children}
  </button>
);

export default PanelTab;
